import { WagmiProvider } from 'wagmi';
import { ReactHooksWrapper, setHook } from 'react-hooks-outside';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import wagmiConfig from 'wagmiConfig';
import { APP_VERSION } from 'constants/index';
import {
  BalanceProvider,
  BookmarkWarningProvider,
  TokenProvider,
  WalletProvider,
  UserProvider,
  WindowProvider,
} from 'context';
import { CollectionsProvider } from 'context/CollectionsContext';
import { BondRoutesProvider } from 'context/BondRoutesContext';
import ErrorBoundary, { SentryUserContext } from 'components/ErrorBoundary';
import useTokenContext from 'hooks/useTokenContext';
import useWalletContext from 'hooks/useWalletContext';

import Root from './Root';

setHook('tokenContext', useTokenContext);
setHook('walletContext', useWalletContext);

const queryClient = new QueryClient();

console.log(
  `%cGMI ${APP_VERSION}`,
  'color:white; font-size: 30px; border: 1rem ridge #00AB58 ; border-radius: 7px; padding: 10px; margin: 20px; -webkit-text-stroke: 1px #00AB58;',
);

function App() {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <WalletProvider>
          <SentryUserContext />
          <TokenProvider>
            <BondRoutesProvider>
              <WindowProvider>
                <BalanceProvider>
                  <UserProvider>
                    <BookmarkWarningProvider>
                      <CollectionsProvider>
                        <ErrorBoundary>
                          <Root />
                        </ErrorBoundary>
                      </CollectionsProvider>
                      <ReactHooksWrapper />
                    </BookmarkWarningProvider>
                  </UserProvider>
                </BalanceProvider>
              </WindowProvider>
            </BondRoutesProvider>
          </TokenProvider>
        </WalletProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
